import LanguageIcon from '@mui/icons-material/Language';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../..';
import AddressCard from '../../components/card/AddressCards/addressCard';
import ListItem from '../../components/card/listItem/listItem';
import WalletLoanCard from '../../components/card/walletCard/walletLoanCard';
import { IGetCategoriesResponse, IGetStoreInfoResponse } from '../../models/store.model';
import { changeRouteType, getpervInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';
import { GetStoreInfo } from '../../services/store.service';
import { IStoreContainerOriginal } from '../navigationButtonComponents/walletContainer/IStoreContainer';
import SellerInfoSkeleton from './sellerInfoSkeleton';



const SellerInfo = ({ setState }: IStoreContainerOriginal) => {
    const dispatch = useDispatch();
    const selectedId = useSelector((state: RootState) => state.headerTitleSlice.sellers);
    const [storeInfo, setStoreInfo] = useState<IGetStoreInfoResponse>()
    const msg = storeInfo?.title ? `فروشگاه ${storeInfo?.title}` : 'فروشگاه';
    const mode = useSelector((state: RootState) => state.theme) as 'light' | 'dark';
    const randomKeyForDispatch = Math.random();
    const [displayedCategories, setDisplayedCategories] = useState<IGetCategoriesResponse[]>()
    const [telephone, setTelephone] = useState<React.ReactElement[]>([])

    const { mutate: GetStoreInfoMutate, isLoading } = useMutation(GetStoreInfo, {
        onSuccess: (data: IGetStoreInfoResponse) => {
            if (data) {
                setStoreInfo(data)
                dispatch(setHeaderTitle({ header: `فروشگاه ${data.title}`, color: 'var(--input-bg-color)', parentRoute: '', }))


                setDisplayedCategories(data.categories)
                const telephone: string | React.ReactElement[] = data.branches[0].phoneNumbers.map((item) => (
                    <a href={`tel:${item}`} style={{ textDecoration: 'none', fontSize: ".85rem" }} key={item}>
                        {item}
                    </a>
                ));
                setTelephone(telephone)
            }
        },
        onError: () => { },
    });

    const stateFromRedux = useSelector((state: RootState) => state.loansTabComponents.prevState);


    useEffect(() => {
        GetStoreInfoMutate({
            storeId: parseInt(selectedId!)
        })
        if (stateFromRedux?.includes('appContainer')) {

            dispatch(changeRouteType({ routeType: 'parent' }));
            dispatch(setHeaderTitle({ header: msg, color: 'var(--input-bg-color)', parentRoute: '', }))
        } else {
            dispatch(changeRouteType({ routeType: 'child' }));
            dispatch(getpervInnerState({ prevInnerState: `sellers ${randomKeyForDispatch}` }));
        }


    }, [])




    const handleBranchesOnClick = () => {
        sessionStorage.setItem("storeTitle", storeInfo?.title ? storeInfo?.title : "");
        sessionStorage.setItem("StoreInfo", JSON.stringify(storeInfo?.branches));
        if (storeInfo?.logoUrl != null) {
            sessionStorage.setItem("StoreInfoLogo", storeInfo?.logoUrl);
        }


        setState!('storeBranches');


    }

    if (isLoading) { return <SellerInfoSkeleton /> }

    return (
        <div className={'grid grid-cols-1 grid-rows-5 px-5 overflow-y-auto h-[calc(100svh-140px)]'}
            style={{ gridTemplateRows: 'auto' }}
        >
            {/* store banner section */}
            <div className='place-content-center  py-5 mt-[-20px] mx-[-20px]'>
                <Grid container justifyContent={"flex-start"} alignItems={"center"} gap={"45px"} flexDirection={"column"}>
                    <Grid item sx={{ width: '100%' }}>
                        <Box sx={{ width: '100%', height: "100%", position: "relative", backgroundColor: "var(--input-bg-color)", minHeight: "120px" }}>
                            {storeInfo?.bannerUrl ?
                                <img style={{ width: "100%", height: "100%", objectFit: "fill" }} alt={storeInfo?.title} src={storeInfo?.bannerUrl} />
                                :
                                <Box sx={{ width: "100%", height: "100%", objectFit: "cover", minHeight: "80px", background: "linear-gradient(0deg, #D7DBEC, var(--tirnary-text-color))" }} />
                            }
                            <Box sx={{ position: "absolute", bottom: "-40px", right: "20px", width: "80px", height: "80px", borderRadius: "50%", background: "#fff", boxShadow: "0px 2px 4px rgba(0,0,0,0.4)", padding: "5px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {storeInfo?.logoUrl ?
                                    <img style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", padding: "10px" }} alt={storeInfo?.title} src={`${storeInfo?.logoUrl}`} /> :
                                    <StorefrontIcon sx={{ color: "#D7DBEC", fontSize: "36px" }} />
                                }
                            </Box>
                        </Box>

                    </Grid>
                    <Grid item width={"100%"} sx={{ paddingRight: "40px !important", marginTop: "10px", paddingLeft: "40px !important" }}>
                        <Grid container justifyContent={"space-between"} alignItems={"flex-end"}>
                            <Box sx={{ display: "flex", alignItems: "flex-start", flexDirection: 'column', justifyContent: "center" }}>
                                <Grid item sx={{ marginBottom: "10px" }}>
                                    <Typography sx={{ fontSize: "1.2rem", color: "var(--primary-text-color)" }}>
                                        {storeInfo?.title}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography sx={{ fontSize: ".75rem", color: "var(--primary-text-color)" }}>
                                        {storeInfo?.type === 'Online' || storeInfo?.type === 'OnlineAndOnsite' ?
                                            <LanguageIcon sx={{ marginLeft: "5px", fontSize: '1rem' }} /> : <StorefrontIcon sx={{ marginLeft: "5px", fontSize: '1rem' }} />
                                        }
                                        فروشگاه {storeInfo?.type === 'Online' ? "آنلاین" : storeInfo?.type === 'OnlineAndOnsite' ? "آنلاین و حضوری" : "حضوری"}
                                    </Typography>
                                </Grid>
                            </Box>
                            {(storeInfo?.type === 'Online' || storeInfo?.type === 'OnlineAndOnsite') &&
                                <Grid item>
                                    <a className='underline text-[#BBA57A] hover:text-[#BBA57A] relative text-sm'
                                        href={storeInfo?.url?.startsWith('https') ? storeInfo?.url : `https://${storeInfo?.url}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        مشاهده سایت فروشگاه
                                    </a>
                                </Grid>}
                            {/* store info section */}
                            <Typography sx={{ fontSize: ".865rem", marginTop: '15px', textAlign: 'justify', color: "var(--primary-text-color)" }}>
                                {storeInfo?.description}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            {/* store categoreis section */}
            <div className={`place-content-center px-5 ${mode === 'dark' ? 'border-[rgba(255,255,255,0.4)]' : 'border-[rgba(0,0,0,0.2)]'}  border-t py-5`}>
                <Typography sx={{ fontSize: "1rem", marginBottom: "10px", color: "var(--primary-text-color)" }}>
                    زمینه فعالیت فروشگاه
                </Typography>
                {/* new Design */}
                <Grid container sx={{ marginTop: "10px", overflowX: "auto" }}>
                    {displayedCategories?.map((category, index) => (
                        <Grid key={index} container xs={4} sm={3} lg={3} xl={3} flexDirection={"row"} sx={{ marginBottom: "15px", justifyContent: 'center', alignItems: "center", gap: "5px", height: "100%" }} className='' >
                            <Grid item sx={{ backgroundColor: `${category.colorCode}`, borderRadius: "25px", padding: "7px !important", gap: "5px" }} >
                                <img className='' src={category.logoUrl ? ` ${category.logoUrl}` : 'images/emptyImage.png'} alt={category.title} style={{
                                    objectFit: 'contain', width: "70px", height: "70px", minWidth: "70px",
                                    minHeight: "70px",
                                    maxWidth: "70px",
                                    maxHeight: "70px"

                                }} />
                            </Grid>
                            <Grid item sx={{ width: "100%", height: "20%" }}>
                                <Typography sx={{ color: "var(--primary-text-color)", fontSize: "0.8rem", textAlign: "center" }}>{category.title}</Typography>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </div>


            {/* store address and phone section */}
            {storeInfo?.branches.length !== 0 && <div className={` ${mode === 'dark' ? 'border-[rgba(255,255,255,0.4)]' : 'border-[rgba(0,0,0,0.2)]'} border-t place-content-center px-5 py-5`}>
                <Typography sx={{ fontSize: "1rem", marginBottom: "1rem", color: "var(--primary-text-color)" }}>
                    آدرس و اطلاعات تماس شعب
                </Typography>
                {storeInfo?.branches.length === 1 ?
                    <AddressCard lable={storeInfo?.branches[0].title} address={storeInfo?.branches[0].address} latitude={storeInfo?.branches[0].lat} longitude={storeInfo?.branches[0].lng} phones={telephone} />
                    :
                    <ListItem onClick={handleBranchesOnClick} title={'لیست شعب حضوری'} id={0} status={`${storeInfo?.branches?.length!} شعبه`} isShown={false} icon={<LocationOnOutlinedIcon sx={{ color: 'var(--tirnary-text-color)' }} />} />
                }


            </div>}
            {/* store cards section todo */}
            {(storeInfo?.wallets && storeInfo?.wallets.length !== 0) && <div className={` ${mode === 'dark' ? 'border-[rgba(255,255,255,0.4)]' : 'border-[rgba(0,0,0,0.2)]'} border-t place-content-center py-5 text-justify px-5`}>
                <Typography sx={{ fontSize: "1rem", marginBottom: "1rem", color: "var(--primary-text-color)" }}>
                    کارت های فروشگاه
                </Typography>

                {<div className='flex flex-col gap-2'>
                    {storeInfo?.wallets.map((wallet, index) => (
                        <WalletLoanCard key={index} amount={wallet.balance} date={wallet.expirationDatePersian} title={wallet.title} color={wallet.colorHexCode} />

                    ))}
                </div>}
            </div>}
        </div >
    )
}

export default SellerInfo
